import { SnackBarService } from "@teammood/shared/ui/snack-bar";
import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { LoggerService } from "@teammood/shared/util/logger";
import { TokenService } from "../token.service";
import { catchError, EMPTY, Subject, takeUntil, tap } from "rxjs";
import { ActivatedRoute, Router } from "@angular/router";


@Component({
    selector: 'expired-token',
    templateUrl: './expired-token.component.html',
    providers: [TokenService],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ExpiredTokenComponent implements OnInit, OnDestroy {
    
    token: string;

    private _destroy$ = new Subject<void>();

    constructor(
        private log: LoggerService,
        private snackBarService: SnackBarService,
        private tokenService: TokenService,
        private route: ActivatedRoute,
        private router: Router,
    ){}

    ngOnInit() {      
        this.token = this.route.snapshot.params['token'];
    }

    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    
    newToken (expiredToken: string){
        this.tokenService.renewToken(expiredToken).pipe(
            tap(async () => {
                this.snackBarService.success('A new token has been generated.');
                await this.router.navigate(['/onboarding/renewedtoken']);
            }),
            catchError(errors => {
                this.log.error(errors.data);
                this.snackBarService.error(errors.data);
                return EMPTY;
            }),
            takeUntil(this._destroy$)
        ).subscribe();
    }
}